export function pairingCompatibilityAnalyticsEnabled(): boolean {
  const configured = import.meta.env.VITE_PAIRING_COMPATIBILITY_ANALYTICS?.trim().toLowerCase();
  if (configured) return ['1', 'true', 'yes', 'on', 'enabled'].includes(configured);
  const host = window.location.hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host.includes('staging.');
}
